module.exports = __webpack_public_path__ + "static/antd-icon-two-toned-f5b273372698e12e624e36f6ca9ecbdc.png";